import React from 'react';
import PropTypes from 'prop-types';

import Button from '../Global/Buttons/Button';
import IconWithText from '../Global/Icons/IconWithText';
import NewFolderButton from './NewFolderButton';

const FolderTypeHeader = ({ folder }) => {
  let header;
  if (folder.shared) {
    header = `Shared Folder`;
  } else {
    header = `Private Folder`;
  }
  return <span className="like-small color-grey text-uppercase fw-medium m-b-1 letter-spacing-s">{header}</span>;
};

FolderTypeHeader.propTypes = {
  folder: PropTypes.object.isRequired,
};

const FolderHeader = ({ folder, onNewFolderClick, canShare, onShareClick, onEditClick }) => (
  <div className="folder-header">
    <div className="border-bottom-1 border-color-grey--light d-flex flex-column align-items-center text-center p-x-3 p-y-4">
      <FolderTypeHeader folder={folder} />
      <h2 className="like-h4 fw-medium m-b-0">{folder.title}</h2>
      {folder.owned_by_me &&
        <ul className="inline-list-new inline-list-new--s m-t-3">
          {canShare &&
            <li>
              <Button onClick={onShareClick} size="s"><IconWithText name="share" size="s">Share</IconWithText></Button>
            </li>
          }
          <li>
            <Button onClick={onEditClick} size="s" classes="btn--secondary"><IconWithText name="edit" size="s">Edit</IconWithText></Button>
          </li>
        </ul>
      }
    </div>

      {folder.owned_by_me &&
        <div className="d-flex align-items-center justify-content-space-between border-bottom-1 border-color-grey--light">
          <NewFolderButton onClick={onNewFolderClick}/>
          <a href="/search?term=" className="content-list-new__list-item link--tertiary fw-medium">
            <IconWithText name="outline-add-box" size="m">Add content</IconWithText>
          </a>
        </div>
      }
  </div>
);

FolderHeader.propTypes = {
  folder: PropTypes.object.isRequired,
  onNewFolderClick: PropTypes.func.isRequired,
  canShare: PropTypes.bool,
  onShareClick: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
};

export default FolderHeader;



// WEBPACK FOOTER //
// ./library/app/components/Folders/FolderHeader.js